var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerminal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 1H3.5C2.65625 1 2 1.6875 2 2.5V12.5C2 13.3438 2.65625 14 3.5 14H11.5V16H6.25C6.09375 16 6 16.125 6 16.25V16.75C6 16.9062 6.09375 17 6.25 17H17.75C17.875 17 18 16.9062 18 16.75V16.25C18 16.125 17.875 16 17.75 16H12.5V14H20.5C21.3125 14 22 13.3438 22 12.5V2.5C22 1.6875 21.3125 1 20.5 1ZM21 12.5C21 12.7812 20.75 13 20.5 13H3.5C3.21875 13 3 12.7812 3 12.5V2.5C3 2.25 3.21875 2 3.5 2H20.5C20.75 2 21 2.25 21 2.5V12.5Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminal);
export default __webpack_public_path__ + "static/media/terminal.b999e2ff.svg";
export { ForwardRef as ReactComponent };